import { Component, inject, Input } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { MaintenanceService } from '../../maintenance.service';
import { MaintenanceTask } from '../../maintenance/MaintenanceTask.model';
import { MaintenanceTaskCompletionDTO } from '../../maintenance/MaintenanceTaskCompletionDTO.model';
import { User } from '../../../models/user.model';
import { ShowPerformance } from '../../../models/showperformance.model';

@Component({
    selector: 'app-maintenance-task-checklist-modal',
    templateUrl: './maintenance-task-checklist-modal.component.html',
    styleUrls: ['./maintenance-task-checklist-modal.component.scss'],
    standalone: false
})
export class MaintenanceTaskChecklistModalComponent {

    @Input() public activeUser!: User;
    @Input() public performance!: ShowPerformance;

    protected name!: string;
    protected maintenanceTasks: MaintenanceTask[] = [];
    protected checkedTasks: MaintenanceTask[] = [];

    private maintenanceService: MaintenanceService = inject(MaintenanceService);
    private modalCtrl: ModalController = inject(ModalController);
    private loadingController: LoadingController = inject(LoadingController);

    constructor() {

        this.loadMaintenanceTasks();
    }

    protected cancel(): Promise<boolean> {
        return this.modalCtrl.dismiss(null, 'cancel');
    }

    protected async confirm(): Promise<boolean> {
      if(!this.activeUser){
        // TODO: Show error
        return this.modalCtrl.dismiss(null, 'cancel');
      }

      if(this.checkedTasks.length === 0){
        return this.modalCtrl.dismiss(null, 'cancel');
      }

      const loader = await this.loadingController.create({
        message: 'Onderhoudstaken opslaan...',
        spinner: 'crescent'
      });
      await loader.present();

      try {

        const today = new Date();
        const performanceDate = new Date(this.performance.datetime);
        const year = performanceDate.getFullYear();
        const month = (performanceDate.getMonth() + 1).toString().padStart(2, '0');
        const day = performanceDate.getDate().toString().padStart(2, '0');
        const hour = today.getHours().toString().padStart(2, '0');
        const minute = today.getMinutes().toString().padStart(2, '0');
        const second = today.getSeconds().toString().padStart(2, '0');

        const taskCompletionDate = `${ year }-${ month }-${ day }T${ hour }:${ minute }:${ second }`;

        // TODO: Dit is hoe het op de maintenance page gaat: await Promise.all(this.selectedMaintenanceTasks.map(async (task) => {
        //             await this.markTaskAsCompleted(task, false);
        //         }));

        // For each checked task, call the api to mark it as completed
        this.checkedTasks.forEach(async task => {
          const completedTask = new MaintenanceTaskCompletionDTO();
          completedTask.taskId = task.id;
          completedTask.userId = this.activeUser.id;
          completedTask.date = taskCompletionDate;

          const response = await this.maintenanceService.markTaskAsCompleted(
              completedTask
          );

        });

      } catch (e) {
        console.error(e);
      } finally {
        await loader.dismiss();
      }

        return this.modalCtrl.dismiss(this.name, 'confirm');
    }

  protected checkTask(task: MaintenanceTask, $event: any): void {
        if ($event.target.checked) {
            this.checkedTasks.push(task);
        }
        else {
            this.checkedTasks = this.checkedTasks.filter(t => t.id !== task.id);
        }

  }

    private getListOfCheckedTasks(): MaintenanceTask[] {
        return this.maintenanceTasks.filter(task => this.checkedTasks.includes(task));
    }

    private async loadMaintenanceTasks(): Promise<void> {
      const allTasks = await this.maintenanceService.getAllMaintenanceTasks();
      const cleaningTasks = allTasks.filter(task => task.maintenanceTaskCategory.name === 'Schoonmaak');
      // Sort by name asc
        this.maintenanceTasks = cleaningTasks.sort((a, b) => a.name.localeCompare(b.name));
    }

}
